import { RequestDataModel } from '@ktvs8/gocoo-engine-front-end';
import { getDay, getToday } from './Program-test-data';

export function findMProgramByTicketKey(requestModel: RequestDataModel) {
  const ticketKey = requestModel.requestData['TicketKey'];
  return MProgramTestData.find((x) => x.TicketKey === ticketKey);
}

/**
 * 発注書のテストデータ
 */
export const MProgramTestData = [
  {
    TicketType: 'MProgram',
    TicketKey: 'test#1111-1111-1111',
    ProgramName: 'モンスターカード',
    ProgramCode: '23',
    Producer: ['ProductionManager@aaa.com', 'Pegasasu@aaa.com'],
    FirstOnairDate: getDay(5),
    OrderCount: '2',
    Subtickets: {
      MProgramOrder: [
        {
          TicketType: 'MProgramOrder',
          TicketKey: '23#orfjier-73yfvbry-fr3g',
          ProgramCode: '23',
          Content: 'VTR1',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'Onairdate',
          Weekday: 'NoLimit',
        },
        {
          TicketType: 'MProgramOrder',
          TicketKey: '23#83y3-vhriu-32ftv-dbj',
          ProgramCode: '23',
          Content: 'VTR2',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'NoLimit',
          Active: true,
        },
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '23#hirg89hf-23byy4g-pppppp',
          ProgramCode: '23',
          Content: 'VTR3',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'Tue',
          Active: true,
        },
      ],
    },
  },
  {
    TicketKey: 'test#1111-1111-1112',
    TicketType: 'MProgram',
    ProgramName: '魔法カード',
    ProgramCode: '1',
    Producer: ['Kaiba@aaa.com', 'Yuugi@aaa.com'],
    FirstOnairDate: '2045/12/10',
    OrderCount: '3',
    Subtickets: {
      MProgramOrder: [
        {
          TicketType: 'MProgramOrder',
          TicketKey: 'test#1111-1111-1112#000-0000-0000',
          ProgramCode: '2',
          Content: '死者蘇生',
          Memo: '死者をよみがえらす',
          ReceiptDateType: 'Onairdate',
          Weekday: 'NoLimit',
        },
        {
          TicketType: 'MProgramOrder',
          TicketKey: 'test#1111-1111-1112#000-0000-0001',
          ProgramCode: '4',
          Content: '強欲な壺',
          Memo: 'ドロー * 2',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: '3',
          Weekday: 'NoLimit',
        },
        {
          TicketType: 'MProgramOrder',

          TicketKey: 'test#1111-1111-1112#000-0000-0002',
          ProgramCode: '4',
          Content: '融合',
          Memo: '合体',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: '4',
          Weekday: 'NoLimit',
        },
      ],
    },
  },
  {
    TicketType: 'MProgram',
    TicketKey: 'test#1111-1111-1113',
    ProgramName: 'テストは',
    ProgramCode: '2',
    Producer: ['ProductionManager@aaa.com', 'Kaiba@aaa.com'],
    FirstOnairDate: '2045/12/10',
    OrderCount: '5',
    Subtickets: {
      MProgramOrder: [
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '27#8bruht-bgork-3nruhr',
          ProgramCode: '27',
          Content: 'VTR1',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'Sun',
          Active: true,
        },
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '49#94n4ig-2nruh3-2vfnei',
          ProgramCode: '49',
          Content: 'VTR2',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'NoLimit',
          Active: true,
        },
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '55#663vyf-bru3r-girgjirgf',
          ProgramCode: '55',
          Content: 'VTR3',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'Tue',
          Active: true,
        },
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '49#83y3-vhriu-32ftv-dbj',
          ProgramCode: '49',
          Content: 'VTR2',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'Sun',
          Active: true,
        },
        {
          TableName: 'ordersheet-issue',
          TicketType: 'MProgramOrder',
          TicketKey: '55#hirg89hf-23byy4g-pppppp',
          ProgramCode: '55',
          Content: 'VTR3',
          LsiKey: null,
          Memo: '融合',
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          OnairWeekday: 'Thu',
          Active: true,
        },
      ],
    },
  },
  {
    TicketType: 'MProgram',
    TicketKey: 'test#1111-1111-1114',
    ProgramName: 'テストに',
    ProgramCode: '3',
    Producer: ['Jounouchi@aaa.com', 'Anzu@aaa.com'],
    FirstOnairDate: '2045/12/10',
    OrderCount: '1',
    Subtickets: [
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '52#8bruht-bgork-3nruhr',
        ProgramCode: '52',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
    ],
  },
  {
    TicketType: 'MProgram',
    TicketKey: 'test#1111-1111-1116',
    ProgramName: 'テストほ',
    ProgramCode: '4',
    Producer: ['Production@aaa.com'],
    FirstOnairDate: '2045/12/10',
    OrderCount: '4',
    Subtickets: [
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '67#8bruht-bgork-3nruhr',
        ProgramCode: '67',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '67#94n4ig-2nruh3-2vfnei',
        ProgramCode: '67',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '90#63vyf-bru3r-girgjirgf',
        ProgramCode: '90',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '9#83y3-vhriu-32ftv-dbj',
        ProgramCode: '9',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
    ],
  },
  {
    TicketType: 'MProgram',
    TicketKey: getToday() + '#Today6',
    ProgramName: 'テストへ',
    ProgramCode: '5',
    Producer: ['Pegasasu@aaa.com'],
    FirstOnairDate: '2023/12/10',
    OrderCount: '8',
    Subtickets: [
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '9#8bruht-bgork-3nruhr',
        ProgramCode: '9',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '13#94n4ig-2nruh3-2vfnei',
        ProgramCode: '13',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '51#63vyf-bru3r-girgjirgf',
        ProgramCode: '51',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '4#83y3-vhriu-32ftv-dbj',
        ProgramCode: '4',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '33#hirg89hf-23byy4g-pppppp',
        ProgramCode: '33',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '15#94n4ig-2nruh3-2vfnei',
        ProgramCode: '15',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '10#63vyf-bru3r-girgjirgf',
        ProgramCode: '10',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '87#83y3-vhriu-32ftv-dbj',
        ProgramCode: '10',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
    ],
  },
  {
    TicketType: 'MProgram',
    TicketKey: getToday() + '#Today7',
    ProgramName: 'テストと',
    ProgramCode: '6',
    Producer: ['ProductionManager@aaa.com'],
    FirstOnairDate: '2023/12/11',
    OrderCount: '3',
    Subtickets: [
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '14#8bruht-bgork-3nruhr',
        ProgramCode: '10',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '1#94n4ig-2nruh3-2vfnei',
        ProgramCode: '1',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
      {
        TableName: 'ordersheet-issue',
        TicketType: 'MProgramOrder',
        TicketKey: '89#63vyf-bru3r-girgjirgf',
        ProgramCode: '10',
        Content: 'VTR3',
        LsiKey: null,
        Memo: '融合',
        ReceiptDateType: 'BeforeOnairdate',
        CountBeforeOnairdate: 7,
        OnairWeekday: 'Thu',
        Active: true,
      },
    ],
  },
  {
    TicketType: 'MProgram',
    TicketKey: getToday() + '#Today8',
    ProgramName: 'テストち',
    ProgramCode: '7',
    Producer: [''],
    OrderCount: '0',
    FirstOnairDate: '2045/12/10',
  },
];

/**
 * 発注書の検索処理
 * @param requestModel
 * @returns
 */
export function filterMProgramBySearchDay(requestModel: RequestDataModel) {
  if ('TicketKey' in requestModel.requestData) {
    return MProgramTestData.filter((data) => data.TicketKey === requestModel.requestData.TicketKey);
  }
  return MProgramTestData;
}
